import { createAction, props } from '@ngrx/store';
import { UserContextSettingsEntity } from './user-context-settings.models';

export const initUserContextSettings = createAction(
  '[UserContextSettings Page] Init'
);

export const loadUserContextSettingsSuccess = createAction(
  '[UserContextSettings/API] Load UserContextSettings Success',
  props<{ userContextSettings: UserContextSettingsEntity[] }>()
);

export const loadUserContextSettingsFailure = createAction(
  '[UserContextSettings/API] Load UserContextSettings Failure',
  props<{ error: unknown }>()
);
